module.exports = __webpack_public_path__ + "static/media/img-location-kaohsiung-zh.da308beb.svg";